import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.pl.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
import { mount } from '../dom-lifecycle';
import { mountRuleValidator } from './validation';
import { validatePolish } from 'validate-polish';
import IBAN from 'iban';
import './files';
import './prize-variant';

$.fn.datepicker.defaults.language = "pl";
$.fn.datepicker.defaults.format = "dd.mm.yyyy";
$.fn.datepicker.defaults.clearBtn = true;
$.fn.datepicker.defaults.defaultViewDate = new Date();
$.fn.datepicker.defaults.maxViewMode = 'decade';
$.fn.datepicker.dates.pl.monthsTitle = 'Miesiące';

mount('input[data-type=datepicker]', el => $(el).datepicker());

mountRuleValidator('input[data-type=pesel]', 'pesel', input => validatePolish.pesel(input.value));
mountRuleValidator('input[data-type=nip]', 'nip', input => validatePolish.nip(input.value));
mountRuleValidator('input[data-type=iban]', 'iban', input => IBAN.isValid(input.value));
